import { memo, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useConfig } from '../../../config';

export const HeaderLogo = memo((): JSX.Element | null => {
	const { logo, storeName } = useConfig();
	const stableLogoRef = useRef<string | null>(null);

	if (stableLogoRef.current === null && logo !== null) {
		stableLogoRef.current = logo;
	}

	if (stableLogoRef.current === null) {
		return null;
	}

	const stableLogo = stableLogoRef.current;
	const id = stableLogo === 'ondio-logo.svg' ? 'logo-ondio' : 'logo';

	return (
		<Link id={id} to="/">
			<img src={`/images/${stableLogo}`} alt={storeName} fetchpriority="high" loading="eager" />
		</Link>
	);
});
